import {useApp} from '@app';
import {useFirstSession} from '@app/useFirstSession';

export const useNavigationBar = (): boolean => {
  const {authorization} = useApp();
  const isFirstSession = useFirstSession();
  return Boolean(authorization) && !isFirstSession;
};
